export const isReferralAvailable = (shop) => [1, 2, 11, 14].includes(shop) // (TH,MY,SG,PH)

export default { isReferralAvailable }
